import Container from '~/components/atoms/Container/Container'
import Fixture from '~/components/atoms/Fixture/Fixture'
import Lozenge from '~/components/atoms/Lozenge/Lozenge'
import Text, { TextSizes } from '~/components/atoms/Text/Text'
import type { PageData } from '~/components/report/types'

import styles from './ReportHeader.module.css'

const ReportHeader = ({
  title,
  subtitle,
  relatedArtists,
  primaryCategory,
}: PageData) => {
  return (
    <Fixture verticalPadding>
      <Container>
        <div className={styles.base}>
          {subtitle && (
            <Text size={TextSizes.primaryTitleSml} Tag="h3">
              {subtitle}
            </Text>
          )}
          <Text size={TextSizes.primaryTitleXLrg} Tag="h1">
            {title}
          </Text>
          <div className={styles.categories}>
            {relatedArtists?.map(item => (
              <Lozenge
                title={item.name}
                link={`/artist-${item.slug}`}
                hideOnZero
              />
            ))}
            <Lozenge
              title={primaryCategory.name}
              hideOnZero
              link={`/market-reports?category=${primaryCategory.slug}#recent-reports`}
            />
          </div>
        </div>
      </Container>
    </Fixture>
  )
}

export default ReportHeader
